import './Login.css';
import React, { useState, useEffect, useRef } from 'react';
import { commonStyles, rtlStyles, ltrStyles } from './accountAuthorizationStyles';
import Password from './components/Password';
import Recaptcha from './components/Recaptcha';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { validateRequired, runValidations, validatePassword } from './commomFunctions';
import { getLatestUserCookie } from './user_session';
import { loaderToggle, setUserCookie } from '../../utils/setUserCookie';
import { qsToObject } from '../../utils/querystring';
import { canUseDOM, get } from '../../utils';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { STEPS } from './AccountAuthorization';
import GoBackBtn from './components/GoBackBtn';
import { redirectToCampaignScriptGenerator, redirectToVideoScriptGenerator } from './EmailAuthentication';
const Login = _ref => {
  let {
    fields,
    params,
    getActiveStep,
    userEmail,
    bmCookies,
    setGlobalLoader,
    getTimerLeft,
    requestEvisaToken,
    getEvisaToken,
    eventsAnalytics
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const [disableSubmit, setDisableSubmit] = useState(false);
  const loginForgotPassword = get(fields, 'data.loginForgotPassword');
  const loginSuccess = get(fields, 'data.loginSuccess');
  const redirectHome = get(fields, 'data.contextItem.redirectPage.jss.value.href');
  const LoginBtnText = mapDictionary.get('Login');
  const ForgetLinkValue = get(fields, 'data.contextItem.forgotPasswordPage.jss.value.href');
  const LabelPassword = mapDictionary.get('Password');
  const ErrorPasswordRequired = mapDictionary.get('FIeldErrorRequiredPassword');
  const errorFormatPassword = mapDictionary.get('error format password');
  const passwordPlaceholder = mapDictionary.get('passwordPlaceholder') || '';
  const recaptchErrorMessage = mapDictionary.get('FieldErrorRequierdRecaptcha');
  const loginPreferredTitle = get(fields, 'data.datasource.loginPreferredTitle.jss.value');
  const loginPreferredSubtitle = get(fields, 'data.datasource.loginPreferredSubtitle.jss.value');
  const loginPreferredButtonLabel = get(fields, 'data.datasource.loginPreferredButtonLabel.jss.value');
  const forgotPasswordButtonLabel = get(fields, 'data.datasource.forgotPasswordButtonLabel.jss.value');
  const goBackLabel = mapDictionary.get('goBackLabel');
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const formErrorInvalidGrant = mapDictionary.get('formErrorInvalidGrant');
  const formErrorNetworOrApiIssue = mapDictionary.get('LoginApiFailError');
  const formErrorUserLocked = mapDictionary.get('ApiErrorUserLockedOutTooManyLoginAttempts');
  const [formResponseError, setFormResponseError] = useState('');
  const [formOtpResponseError, setFormOtpResponseError] = useState('');
  const [fieldPassword, setFieldPassword] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  let referBack = false;
  let referrer = '/';
  let urlParams = null;
  if (canUseDOM) {
    urlParams = qsToObject(window.location.href);
    if (urlParams.redirect_url && urlParams.redirect_url.length) {
      referBack = true;
      referrer = urlParams.redirect_url;
    }
  }
  let homeURL;
  if (canUseDOM) {
    homeURL = window.location.origin;
    homeURL += redirectHome;
  }
  useEffect(() => {
    if (fieldPassword) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [fieldPassword]);
  let allErrors = [];
  const [recaptchaError, setRecaptchaError] = useState('');
  const recaptchaRef = useRef(null);

  // Password Field Start

  const passwordFieldProps = {
    value: fieldPassword,
    fieldError: errorPassword,
    setError: setErrorPassword,
    label: LabelPassword,
    type: 'password',
    id: mapDictionary.get('Password'),
    name: mapDictionary.get('Password'),
    placeholder: passwordPlaceholder,
    labelLight: false,
    passLink: null,
    errorRequired: ErrorPasswordRequired,
    errorValue: errorFormatPassword,
    autoComplete: 'current-password',
    required: true,
    changeEvent: value => {
      setFieldPassword(value);
    },
    blurEvent: value => {
      passwordFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fieldPassword;
      return runValidations([validateRequired, validatePassword], value, passwordFieldProps);
    }
  };
  allErrors.push(passwordFieldProps);
  // Password Field End

  // Validate all fields on submit
  const validateAllFields = () => {
    let success = true;
    for (const fieldObj of allErrors) {
      if (!fieldObj.validate()) {
        success = false;
      }
    }
    return success;
  };
  const successFunction = platformName => {
    if (canUseDOM) {
      if (requestEvisaToken) {
        getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
          if (userCookie && userCookie.access_token) {
            console.log('getEvisaToken login', userCookie.access_token);
            getEvisaToken(userCookie.access_token);
          }
        });
      } else {
        if (redirectToCampaignScriptGenerator()) return;
        if (redirectToVideoScriptGenerator()) return;
        if (referBack) {
          window.location = referrer;
        } else {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['loginSuccess'], params), 'email');
          window.location.href = homeURL;
        }
      }
    }
  };

  // Form submit handler
  const formSubmit = event => {
    setFormResponseError('');
    if (validateAllFields()) {
      loaderToggle(true, setDisableSubmit);
      setGlobalLoader(true);
      loginUser();
    }
    event.preventDefault();
  };
  const loginUser = async () => {
    let formdata = new FormData();
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(recaptchErrorMessage);
    } else {
      setRecaptchaError('');
    }
    formdata.append('grant_type', 'password');
    formdata.append('client_id', clientId);
    formdata.append('client_secret', clientSecret);
    formdata.append('scope', 'api.read    IdentityServerApi   offline_access');
    formdata.append('username', userEmail);
    formdata.append('password', fieldPassword);
    formdata.append('g-recaptcha-response', recaptchaToken);
    let myHeaders = new Headers();
    if (bmCookies._abck || bmCookies.ak_bmsc || bmCookies.bm_mi || bmCookies.bm_sv || bmCookies.bm_sz) {
      myHeaders.append('Cookie', `
            ${bmCookies._abck ? `_abck=${bmCookies._abck}; ` : ''}
            ${bmCookies.ak_bmsc ? `ak_bmsc=${bmCookies.ak_bmsc}; ` : ''}
            ${bmCookies.bm_mi ? `bm_mi=${bmCookies.bm_mi}; ` : ''}
            ${bmCookies.bm_sv ? `bm_sv=${bmCookies.bm_sv}; ` : ''}
            ${bmCookies.bm_sz ? `bm_sz=${bmCookies.bm_sz}; ` : ''}
        `);
    }
    let requestOptions = {
      credentials: 'include',
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: myHeaders
    };
    let statusCode = 0;
    await fetch(`${identityGlobal}/connect/token`, requestOptions).then(response => {
      statusCode = response.status;
      return response.text();
    }).then(result => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 400) {
        const error = responseObj.error;
        if (error === 'invalid_grant') {
          if (responseObj.error_description === 'locked_out') {
            throw Error(formErrorUserLocked);
          } else {
            throw Error(formErrorInvalidGrant);
          }
        } else if (error === 'invalid_client') {
          throw Error(formErrorNetworOrApiIssue);
        } else {
          throw Error(formErrorNetworOrApiIssue);
        }
      } else if (statusCode === 200) {
        if (responseObj.access_token) {
          setUserCookie(responseObj);
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), LoginBtnText);
          successFunction('Default');
        }
      } else {
        throw Error(formErrorNetworOrApiIssue);
      }
    }).catch(error => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      if (statusCode === 0) {
        setFormResponseError(formErrorNetworOrApiIssue);
      } else {
        setFormResponseError(error.message);
      }
    });
  };
  const requestOTP = async () => {
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(recaptchErrorMessage);
    } else {
      setRecaptchaError('');
    }
    let raw = {
      client_id: clientId,
      'g-recaptcha-response': recaptchaToken,
      email: userEmail
    };
    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    if (bmCookies._abck || bmCookies.ak_bmsc || bmCookies.bm_mi || bmCookies.bm_sv || bmCookies.bm_sz) {
      myHeaders.append('Cookie', `
            ${bmCookies._abck ? `_abck=${bmCookies._abck}; ` : ''}
            ${bmCookies.ak_bmsc ? `ak_bmsc=${bmCookies.ak_bmsc}; ` : ''}
            ${bmCookies.bm_mi ? `bm_mi=${bmCookies.bm_mi}; ` : ''}
            ${bmCookies.bm_sv ? `bm_sv=${bmCookies.bm_sv}; ` : ''}
            ${bmCookies.bm_sz ? `bm_sz=${bmCookies.bm_sz}; ` : ''}
        `);
    }
    let requestOptions = {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(raw),
      redirect: 'follow',
      headers: myHeaders
    };
    let statusCode = 0;
    loaderToggle(true, setDisableSubmit);
    setGlobalLoader(true);
    await fetch(`${identityGlobal}/api/account/requestOtp`, requestOptions).then(response => {
      statusCode = response.status;
      return response.text();
    }).then(result => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 400) {
        throw Error(formErrorNetworOrApiIssue);
      } else if (statusCode === 200) {
        // setUserCookie(responseObj);
        if (!responseObj.isSuccess) {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), loginPreferredButtonLabel);
          const errorObject = responseObj.errors.find(errorItem => {
            return errorItem.code === 'otp_frequency';
          });
          const secondsLeft = Number(errorObject.errorMessage);
          getTimerLeft(secondsLeft);
        }
        getActiveStep(STEPS.STEP7);
      } else {
        throw Error(formErrorNetworOrApiIssue);
      }
    }).catch(error => {
      loaderToggle(false, setDisableSubmit);
      setGlobalLoader(false);
      if (statusCode === 0) {
        setFormOtpResponseError(formErrorNetworOrApiIssue);
      } else {
        setFormOtpResponseError(error.message);
      }
    });
  };
  const stepBack = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), goBackLabel);
    getActiveStep(STEPS.STEP1);
  };
  if (!fields) {
    console.warn('Login component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[Login component is empty: please provide datasource]");
    }
    return null;
  }
  const LoginForm = /*#__PURE__*/React.createElement("div", {
    className: `lr__form form-elements ${rtl ? rtlStyles : ltrStyles} ${commonStyles}
     ${rtl ? rtlStylesLogin : ltrStylesLogin} ${commonStylesLogin}`
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: event => formSubmit(event),
    noValidate: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(Password, passwordFieldProps))), formResponseError && formResponseError.length || recaptchaError ? /*#__PURE__*/React.createElement("div", {
    className: `lr__error server-error ${recaptchaError ? 'recaptcha-error' : ''}`
  }, formResponseError || recaptchaError) : null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary lr__btn-submit",
    type: "submit",
    disabled: disableSubmit
  }, LoginBtnText), /*#__PURE__*/React.createElement("div", {
    className: "links-section"
  }, /*#__PURE__*/React.createElement(GoBackBtn, {
    label: goBackLabel,
    handleClick: stepBack
  }), /*#__PURE__*/React.createElement(RouterLink, {
    className: 'btn btn-tertiary',
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['signinCTAsAnalytics'], params), forgotPasswordButtonLabel);
    },
    href: ForgetLinkValue
  }, forgotPasswordButtonLabel))), /*#__PURE__*/React.createElement("div", {
    className: "otp-login"
  }, loginPreferredTitle && /*#__PURE__*/React.createElement("span", {
    className: "otp-login-title"
  }, loginPreferredTitle), loginPreferredSubtitle && /*#__PURE__*/React.createElement("span", {
    className: "otp-login-subtitle"
  }, loginPreferredSubtitle), loginPreferredButtonLabel && /*#__PURE__*/React.createElement("button", {
    onClick: requestOTP,
    className: "btn btn-secondary otp-login-btn"
  }, loginPreferredButtonLabel), formOtpResponseError && formOtpResponseError.length || recaptchaError ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: `lr__error ${recaptchaError ? 'recaptcha-error' : ''}`
  }, formOtpResponseError || recaptchaError)))) : null), /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: '',
    ref: recaptchaRef
  }));
  return LoginForm;
};
const commonStylesLogin = "c158ws5d";
const ltrStylesLogin = "l1pstny6";
const rtlStylesLogin = "r1yg70yj";
export default Login;